import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FilterService} from './filter.service';
import {APIInterceptor} from './interceptors/api.interceptor';
import {BrandingService} from './core/branding.service';
import {SettingsService} from './core/settings.service';
import {MobileBridgeService} from './core/mobile-bridge.service';
import {NavigationRouteInheritanceService} from './navigation-route-inheritance.service';

const services = [
  FilterService,
  APIInterceptor,
  BrandingService,
  SettingsService,
  MobileBridgeService,
  NavigationRouteInheritanceService,
];

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [...services],
})
export class ServicesModule {}
